import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Lenis from 'lenis';
import { useTheme } from '../../context/ThemeContext';
import usePageSEO from '../../hooks/usePageSEO';
import { HeroCinematic, ProblemStory } from './HeroProblem';
import { MethodSticky, ProcessTimeline } from './MethodTimeline';
import { ComparisonBento, PricingBlock } from './ComparePricing';
import { FaqSection, FinalCta, FloatingCta, GlassNav } from './FaqCta';

export default function LongHairFuePage() {
  const { isDark } = useTheme();

  usePageSEO({
    title: 'Long Hair FUE: Haartransplantation ohne Rasur | Dion Hair Clinic',
    description:
      'Long Hair FUE – die Premium-Haartransplantation komplett ohne Rasur. Sofort gesellschaftsfähig, maximale Diskretion. Jetzt kostenlos beraten lassen.',
    keywords:
      'Long Hair FUE, Haartransplantation ohne Rasur, unrasierte Haartransplantation, FUE ohne Rasur, Dion Hair Clinic',
    canonical: 'https://dionhairclinic.de/longhairfue',
    ogTitle: 'Long Hair FUE: Haartransplantation komplett ohne Rasur',
    ogDescription:
      'Die diskreteste Haartransplantation: Haare in voller Länge verpflanzt, am nächsten Tag gesellschaftsfähig.',
    ogUrl: 'https://dionhairclinic.de/longhairfue',
  });

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div
      data-testid="longhairfue-page"
      className={`relative overflow-x-clip transition-colors duration-500 ${
        isDark ? 'bg-slate-950 text-slate-50' : 'bg-slate-50 text-slate-900'
      }`}
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <GlassNav />
      <HeroCinematic />
      <ProblemStory />
      <MethodSticky />
      <ProcessTimeline />
      <ComparisonBento />
      <PricingBlock />
      <FaqSection />
      <FinalCta />
      <FloatingCta />

      <footer
        className={`py-10 px-6 border-t text-sm ${
          isDark ? 'border-slate-800 text-slate-500' : 'border-slate-200 text-slate-500'
        }`}
      >
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <span>© {new Date().getFullYear()} Dion Hair Clinic · Mönchengladbach</span>
          <div className="flex gap-6">
            <Link data-testid="lhf-footer-impressum" to="/impressum" className="hover:text-[#7BA7C2] transition-colors">Impressum</Link>
            <Link data-testid="lhf-footer-datenschutz" to="/datenschutz" className="hover:text-[#7BA7C2] transition-colors">Datenschutz</Link>
            <Link data-testid="lhf-footer-agb" to="/agb" className="hover:text-[#7BA7C2] transition-colors">AGB</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
